import { Header } from "@components/site/Header"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export const meta: ViewMeta = {
  templateName: "Generic Page",
}

export default defineView("template-generic", (props) => {
  return (
    <>
      <Header />
      <div className="relative w-full">
        <ContentBlocks blocks={props.page?.contentBlocks} />
      </div>
    </>
  )
})
